module.exports = __webpack_public_path__ + "static/media/naranja_big.1847f2bc.png";